import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface GoatCounter {
  count: (vars?: { path?: string }) => void;
}

function getGoatCounter(): GoatCounter | undefined {
  const gc = (window as unknown as { goatcounter?: unknown }).goatcounter;
  if (
    typeof gc === 'object' &&
    gc !== null &&
    typeof (gc as { count?: unknown }).count === 'function'
  ) {
    return gc as GoatCounter;
  }
  return undefined;
}

/**
 * Signale les navigations SPA à GoatCounter.
 * Le script count.v5.js compte lui-même la première page : on ne
 * déclenche donc qu'à partir du deuxième changement d'URL.
 */
export function useAnalytics(): void {
  const { pathname } = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    getGoatCounter()?.count({ path: pathname });
  }, [pathname]);
}
